import Build from '../core/Build';
import GenConfig from '../core/GenConfig';
import { buildToStorage } from './buildStorage';

const STORAGE_KEY = 'dofgen_ai_chat_history';
const MAX_STORED = 3;

function serializeSolverResult(solverResult) {
    if (!solverResult || typeof solverResult !== 'object') return {};
    const { build, ...rest } = solverResult;
    return rest;
}

function serializeBuildMessage(message) {
    const buildData = message.build
        ? buildToStorage(message.build)
        : null;
    const genConfigData = message.genConfig
        ? (typeof message.genConfig.toObject === 'function'
            ? message.genConfig.toObject()
            : message.genConfig)
        : null;
    return {
        ...message,
        build: buildData,
        genConfig: genConfigData,
        solverResult: serializeSolverResult(message.solverResult),
    };
}

function serializeMessages(messages) {
    return messages.map((m) => {
        if (m.kind === 'build') return serializeBuildMessage(m);
        return m;
    });
}

function hydrateBuildMessage(message) {
    if (message.kind !== 'build' || !message.build) return message;
    try {
        return {
            ...message,
            build: new Build(message.build),
            genConfig: new GenConfig(message.genConfig || {}),
            solverResult: message.solverResult && typeof message.solverResult === 'object'
                ? message.solverResult
                : {},
        };
    } catch {
        const {
            build: _build,
            genConfig: _genConfig,
            solverResult: _solverResult,
            ...rest
        } = message;
        return rest;
    }
}

export function hydrateMessages(messages) {
    return (messages || []).map((m) => {
        if (m.kind === 'build') return hydrateBuildMessage(m);
        return m;
    });
}

export function saveConversation({ id, messages, transcript, lang }) {
    if (!id || !messages || messages.length === 0) return;
    const firstUserMsg = messages.find((m) => m.role === 'user');
    if (!firstUserMsg) return;
    try {
        const existing = loadConversations();
        const entry = {
            id,
            savedAt: Date.now(),
            label: String(firstUserMsg.content || '').slice(0, 100),
            messages: serializeMessages(messages),
            transcript,
            lang,
        };
        const filtered = existing.filter((c) => c.id !== id);
        const updated = [entry, ...filtered].slice(0, MAX_STORED);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    } catch {
        // localStorage unavailable or quota exceeded — fail silently
    }
}

export function loadConversations() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        return JSON.parse(raw) || [];
    } catch {
        return [];
    }
}

export function loadConversation(id) {
    if (!id) return null;
    const stored = loadConversations().find((c) => c.id === id) || null;
    if (!stored) return null;
    return {
        ...stored,
        messages: hydrateMessages(stored.messages),
    };
}
